import React from 'react';
import { Box, Card, Stack, Typography, Divider } from '@mui/material';

const ParticipantSummary = ({ summary }) => {
  if (!summary) return null;

  const stats = [
    { label: 'Toplam', value: summary.totalParticipants ?? 0 },
    { label: 'Onaylı', value: summary.approvedCount ?? 0 },
    { label: 'Katıldı', value: summary.attendedCount ?? 0 },
    { label: 'Gelmedi', value: summary.absentCount ?? 0 },
    { label: 'İptal', value: summary.cancelledCount ?? 0 },
    { label: 'Beklemede', value: summary.pendingCount ?? 0 },
    { label: 'Sırada Bekliyor', value: summary.waitingListCount ?? 0 },
  ];

  const rates = [
    { label: 'Katılım Oranı', value: Number(summary.attendanceRate ?? 0).toFixed(1) },
    { label: 'İptal Oranı', value: Number(summary.cancellationRate ?? 0).toFixed(1) },
    { label: 'Gelmedi Oranı', value: Number(summary.absenceRate ?? 0).toFixed(1) },
  ];

  return (
    <Card
      sx={{
        p: 2.5,
        border: '1px solid #e7e7e7',
        boxShadow: 'none',
        borderRadius: '8px',
      }}
    >
      <Stack spacing={3}>
        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 500, color: '#444444' }}>
          Katılımcı Özeti
        </Typography>
        
        {/* İstatistikler */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)', lg: 'repeat(7, 1fr)' },
            gap: 2,
          }}
        >
          {stats.map((stat, index) => (
            <Box key={index}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: '13px',
                  color: '#666666',
                  fontWeight: 500,
                  mb: 0.5,
                }}
              >
                {stat.label}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: '24px',
                  fontWeight: 600,
                  color: '#444444',
                }}
              >
                {stat.value}
              </Typography>
            </Box>
          ))}
        </Box>

        <Divider sx={{ borderColor: '#e6e6e6' }} />

        {/* Oranlar */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {rates.map((rate, index) => (
            <Box key={index}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: '13px',
                  color: '#666666',
                  fontWeight: 500,
                  mb: 0.5,
                }}
              >
                {rate.label}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: '24px',
                  fontWeight: 600,
                  color: '#444444',
                }}
              >
                {rate.value}%
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Zaman bilgileri */}
        {(summary.averageAttendanceTime || summary.averageDelay) && (
          <>
            <Divider sx={{ borderColor: '#e6e6e6' }} />
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                gap: 2,
              }}
            >
              {summary.averageAttendanceTime && (
                <Box>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '13px',
                      color: '#666666',
                      fontWeight: 500,
                      mb: 0.5,
                    }}
                  >
                    Ort. Katılım Zamanı
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '14px',
                      color: '#444444',
                      fontWeight: 500,
                    }}
                  >
                    {new Date(summary.averageAttendanceTime).toLocaleString('tr-TR')}
                  </Typography>
                </Box>
              )}
              {summary.averageDelay && (
                <Box>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '13px',
                      color: '#666666',
                      fontWeight: 500,
                      mb: 0.5,
                    }}
                  >
                    Ort. Gecikme
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '14px',
                      color: '#444444',
                      fontWeight: 500,
                    }}
                  >
                    {summary.averageDelay}
                  </Typography>
                </Box>
              )}
            </Box>
          </>
        )}
      </Stack>
    </Card>
  );
};

export default ParticipantSummary;

